import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'mar-input-search',
    templateUrl: './input-search.component.html',
    styleUrls: ['./input-search.component.scss']
})
export class InputSearchComponent implements OnInit {
    searchValue = '';
    @Output() actionSearch = new EventEmitter<any>();
    @Input() inputLength = 255;
    @Input() placeHolder = '';

    constructor() { }

    ngOnInit(): void {
    }
    search() {
        this.actionSearch.emit(this.searchValue);
    }

}
